import { render } from "./ImpersonateNotification.vue?vue&type=template&id=5f391739&scoped=true"
import script from "./ImpersonateNotification.vue?vue&type=script&lang=js"
export * from "./ImpersonateNotification.vue?vue&type=script&lang=js"

import "./ImpersonateNotification.vue?vue&type=style&index=0&id=5f391739&lang=scss&scoped=true"
import "./ImpersonateNotification.vue?vue&type=style&index=1&id=5f391739&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f391739"]])

export default __exports__